import React, { useEffect, useState } from "react";
import { getSecureUser } from "../utils/secureStorage";
import axios from "axios";
import DOMPurify from "dompurify";
import {
  Alert,
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Slide,
} from "@mui/material";
import { BsFillPlusCircleFill } from "react-icons/bs";
import Loader from "../components/Loader";

export default function ViewCourses() {
  const [viewData, setViewData] = useState([]);
  const [userData, setUserData] = useState({});
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    const storedUser = getSecureUser();
    setUserData(storedUser);

    const data = {
      name: DOMPurify.sanitize(storedUser.org),
      studentID: DOMPurify.sanitize(storedUser.id),
    };

    const url = `${process.env.REACT_APP_API}/enrollment/view_courses`;
    axios.post(url, data, { withCredentials: true })
      .then((res) => setViewData(res.data.course))
      .catch((error) => console.log(error));
  }, []);

  const handleSubmit = async (id) => {
    setLoader(true)
    const url = `${process.env.REACT_APP_API}/enrollment/enrol`;
    const data = {
      studentId: userData.id,
      scheduleId: id,
    };
    try {
      await axios.post(url, data, { withCredentials: true });
      setSuccessAlert(true);
      setTimeout(() => setSuccessAlert(false), 5000);
    } catch (error) {
      const err = error.response?.data?.error;
      setError(err || "An error occurred while enrolling");
      setErrorAlert(true);
      setTimeout(() => setErrorAlert(false), 5000);
    } finally {
      setLoader(false)
    }
  };

  return (
    <Box p={3}>
      <Loader open={loader} text="Please wait..." />
      <Typography variant="h4" gutterBottom align="center">
        Available Courses
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center">
        <Slide direction="down" in={errorAlert} mountOnEnter unmountOnExit>
          <Alert severity="error" sx={{ mb: 2, width: "50%" }}>
            {error}
          </Alert>
        </Slide>

        <Slide direction="down" in={successAlert} mountOnEnter unmountOnExit>
          <Alert severity="success" sx={{ mb: 2, width: "50%" }}>
            Course Enrolled Successfully
          </Alert>
        </Slide>
      </Box>

      {viewData.length > 0 ? (
        <TableContainer component={Paper} sx={{ mt: 3, maxHeight: "70vh" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                {[
                  "S.No", "Course No", "Code", "Batch", "Name", "Start Date", "Duration",
                  "Capacity", "Eligibility", "Category", "Mode", "Type", "Officer",
                  "Faculty", "Description", "Enroll"
                ].map((heading, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      fontSize: "0.7rem",
                      backgroundColor: "#1050A2",
                      color: "white",
                      px: 1,
                      textAlign: "center"
                    }}
                    align={i === 0 ? "center" : "left"}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {viewData.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                    "&:hover": { backgroundColor: "#facb1524" }
                  }}
                >
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell>{data.course_no}</TableCell>
                  <TableCell>{data.code}</TableCell>
                  <TableCell>{data.batch_no}</TableCell>
                  <TableCell>{data.coursename}</TableCell>
                  <TableCell>{data.commencementdate}</TableCell>
                  <TableCell>{data.duration}</TableCell>
                  <TableCell>{data.capacity}</TableCell>
                  <TableCell>{data.eligibility}</TableCell>
                  <TableCell>{data.category}</TableCell>
                  <TableCell>{data.mode}</TableCell>
                  <TableCell>{data.type}</TableCell>
                  <TableCell>{data.officer}</TableCell>
                  <TableCell>{data.faculty}</TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 120,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                    title={data.coursedescription}
                  >
                    {data.coursedescription}
                  </TableCell>
                  <TableCell>
                     <IconButton
                      color="primary"
                      onClick={() => handleSubmit(data.scheduling_id)}
                    >
                      <BsFillPlusCircleFill />
                    </IconButton> 
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography align="center" mt={10} fontSize="1.5rem">
          No courses available at the moment.
        </Typography>
      )}

    </Box>
  );
}
